import { Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";

const Input = ({
  name,
  control,
  label,
  type,
  className,
  errors,
  disabled,
  isRequired,
  onChange,
  max,
  min,
  maxLength,
  placeholder,
  defaultValue,
  validationRules,
  onComplete,
  keyfilter,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? "Campo obrigatório." : false,
        ...validationRules,
      }}
      render={({ field, fieldState }) => (
        <>
          {label && (
            <label
              htmlFor={field.name}
              className={fieldState.error ? "p-error" : ""}
            ></label>
          )}
          <FloatLabel className="w-100">
            <InputText
              id={field.name}
              name={field.name}
              value={field.value || defaultValue || ""}
              placeholder={placeholder}
              disabled={disabled}
              type={type || "text"}
              className={`w-100 form-control ${className}`}
              onChange={(e) => {
                field.onChange(e.target.value);
                onChange && onChange(e); // Repasse do evento onChange
              }}
              onBlur={(e) => field.onChange(e.target.value)}
              maxLength={maxLength}
              max={max}
              min={min}
              onComplete={(e) => onComplete && onComplete(e.value)}
              {...(keyfilter && { keyfilter })}
            />
            {label && <label htmlFor={field.name}>{label}</label>}
          </FloatLabel>
          {errors && errors[name] && (
            <span className="p-error">{errors[name].message}</span>
          )}
        </>
      )}
    />
  );
};

export default Input;
